import type { DataStatus } from '@/shared/lib';

interface ProductApplicationBase {
  id: string;
  productId: string;
  createdAt: string;
  updatedAt: string;
}

export enum WebApplicationType {
  webApplication = 'web application',
  website = 'website',
}

export interface WebApplication extends ProductApplicationBase {
  platform: ApplicationPlatform.web;
  name: string;
  webUrl: string;
  applicationType: WebApplicationType;
}

export interface AndroidApplication extends ProductApplicationBase {
  platform: ApplicationPlatform.android;
  name: string;
  logoUrl: string;
  bundleId: string;
  integrationId: string;
}

export interface IOSApplication extends ProductApplicationBase {
  platform: ApplicationPlatform.ios;
  bundleId: string;
  name: string;
  logoUrl: string;
  appstoreId: string;
  integrationId: string;
}

export enum ApplicationPlatform {
  web = 'web',
  android = 'android',
  ios = 'ios',
}

export type ProductApplication =
  | WebApplication
  | AndroidApplication
  | IOSApplication;

export enum WebLinkType {
  webFunnel = 'web funnel',
  web2App = 'web2app',
}
export interface ProductWebfunnelLink {
  id: string;
  url: string;
  type: WebLinkType;
  productId: string;
  createdAt: string;
  updatedAt: string;
}

export interface ProductWebhook {
  id: string;
  sourceIntegrationId: string;
  productId: string;
  webhookPath: string;
  appHash: string;
  applicationIds: string[];
  createdAt: string;
  updatedAt: string;
}

export interface Product {
  id: string;
  name: string;
  applicationPlatforms: ApplicationPlatform[];
  applications: ProductApplication[];
  applicationsDataStatus: DataStatus;
  webfunnelLinks: ProductWebfunnelLink[];
  webfunnelLinksDataStatus: DataStatus;
  webhooks: ProductWebhook[];
  webhooksDataStatus: DataStatus;
  createdAt: string;
  updatedAt: string;
}
